import {
  DELETE_CONTACT,
  DELETE_CONTACT_FAILURE,
  DELETE_CONTACT_SUCCESS,
  GET_CONTACTS,
  GET_CONTACTS_FAILURE,
  GET_CONTACTS_SUCCESS,
  GET_SINGLE_CONTACT,
  GET_SINGLE_CONTACT_FAILURE,
  GET_SINGLE_CONTACT_SUCCESS,
} from "./actionTypes";

export const getContacts = () => {
  return {
    type: GET_CONTACTS,
  };
};

export const getContactsSuccess = (country) => {
  return {
    type: GET_CONTACTS_SUCCESS,
    payload: country,
  };
};

export const getContactsFailure = (error) => {
  return {
    type: GET_CONTACTS_FAILURE,
    payload: error,
  };
};

export const getSingleContact = (id) => {
  return {
    type: GET_SINGLE_CONTACT,
    payload: id,
  };
};

export const getSingleContactSuccess = (country) => {
  return {
    type: GET_SINGLE_CONTACT_SUCCESS,
    payload: country,
  };
};

export const getSingleContactFailure = (error) => {
  return {
    type: GET_SINGLE_CONTACT_FAILURE,
    payload: error,
  };
};

export const deleteContact = (id) => {
  return {
    type: DELETE_CONTACT,
    payload: id,
  };
};

export const deleteContactSuccess = (id) => {
  return {
    type: DELETE_CONTACT_SUCCESS,
    payload: id,
  };
};

export const deleteContactFailure = (error) => {
  return {
    type: DELETE_CONTACT_FAILURE,
    payload: error,
  };
};
